<template>
    <div ref="container" style="width: 100%; height: 100%;">
        <canvas ref="canvas" style="width: 100%; height: 100%;" :width="size" :height="size" />
    </div>
</template>

<script>
import { ref, watch } from 'vue'

export default {
    props: {
        canvas: {
            type: Object,
        },
        imageData: {
            type: Object,
        },
        size: {
            type: Number,
            default: 224
        }
    },
    methods: {
        init(){
            if (this.imageData) {
                this.$refs.canvas.getContext('2d').putImageData(this.imageData, 0, 0)
            }
            if (this.canvas) {
                this.$refs.canvas.getContext('2d').drawImage(this.canvas, 0, 0)
            }
        }
    },
    mounted(){
        this.init();

        watch(() => this.imageData, (newValue) => {
            this.init()
        },{deep:true});

        watch(() => this.canvas, (newValue) => {
            this.init()
        },{deep:true});
    }
};
</script>
